import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BackendPaths } from '@common/backend-paths';
import { DataService } from '@data/data.service';
import { InputModule } from '@input/input.module';
import { InputComponent } from '@input/input/input.component';
import { NotificationService } from '@notification/notification.service';
import { GlobalEventServiceService } from '@services/global-event-service.service';
import { ensureArray } from '@util/utils';

@Component({
  selector: 'app-email-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressBarModule,
    FormsModule,
    InputModule,
  ],
  templateUrl: './email-dialog.component.html',
})
export class EmailDialogComponent implements OnInit {
  title = 'E-Mail-Versand';

  isWaiting = false;

  protected _mailInput!: InputComponent;
  @ViewChild('mail', {
    read: InputComponent,
  })
  set mail(email: InputComponent) {
    this._mailInput = email;
  }

  emailAddress = '';

  logs: any[] = [];
  logVisible = false;

  _data: any = {};

  lastSuccess = false;

  canSend = false;

  initFromData(data: any) {
    this.logs = ensureArray(data?.emailLogs);
    this.lastSuccess = !!data?.emailState;
  }

  constructor(
    public dialogRef: MatDialogRef<EmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    private notificationService: NotificationService,
    private globalEventService: GlobalEventServiceService
  ) {

    if (dialogData.title) {
      this.title = dialogData.title;
    }
    this._data = dialogData.data;
    this.initFromData(this._data);
  }

  addressChange($event: any) {
    const txt = ($event || '').trim();
    let err = '';

    if (txt) {
      const emailVal = Validators.pattern(
        '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
      );
      const control = new UntypedFormControl(txt, emailVal);
      if (control.errors) {
        err = 'E-Mail-Adresse ist ungültig.';
      }
    } else {
      err = 'E-Mail-Adresse ist leer.';
    }

    if (this._mailInput) {
      this._mailInput.setError(err);
      //this._mailInput.refreshView();
    }
    this.canSend = !err;
    if (this.canSend) {
      this.emailAddress = txt;
    }
  }

  ngOnInit(): void {}

  doCancel() {
    this.dialogRef.close(null);
  }

  doSend() {
    if (!this.canSend) {
      this.notificationService.showErrors([
        'Momentan kann die E-Mail nicht versendet werden',
      ]);
      return;
    }

    const orderId = this._data.orderId;
    const url = BackendPaths.DOCUMENTS + orderId + '/email';
    const data = {
      op: 'email-receipt',
      email: this.emailAddress,
    };

    this.canSend = false;
    this.isWaiting = true;

    this.dataService.post(url, data).subscribe((result: any) => {
      this.canSend = true;
      this.isWaiting = false;

      const res = result?.result;

      if (res?.item) {
        this.updateItem(res.item);
        this.globalEventService.sendEvent('order-email', res.item);
      }

      if (res?.success) {
        const msg = res.msg || 'E-Mail versandt.';
        this.notificationService.showSuccess(msg);

        this.dialogRef.close(null);
      } else {
        let errors: any[] = Array.isArray(res?.errors)
          ? res.errors
          : ['Fehler beim Versenden der E-Mail.'];

        this.notificationService.showErrors(errors);
      }
    });
  }

  updateItem(item: any) {
    if (item.emailLogs) {
      this._data.emailLogs = item.emailLogs;
    }
    this._data.emailState = item.emailState;

    this.initFromData(this._data);
  }

  showLog(show: boolean) {
    this.logVisible = show;
  }
}
